/* eslint-disable no-plusplus */
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { getFileWithSignedUrl } from '../../../shared/actions/Files';
import Image from '../../../shared/components/Image';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../shared/components/VerbButton';
import VerbHeading from '../../../shared/components/VerbHeading';
import { DEFAULT_DISCUSSION_PROMPTS, MODALS, PROMPT_TYPES, SEGMENT_EVENTS } from '../../../shared/Constants';
import { IMAGE_PROPS } from '../../../shared/utils/ImageUtils';

let showDownloadButton = true;
let showManagerHeading = false;
let showGroupHeading = false;
export default class MyCollectionTrackDiscussionTab extends Component {
    static propTypes = {
        userCollection: PropTypes.object,
        loggedInUserCompany: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        isTeamAdmin: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        learningAssetsById: PropTypes.object,
        showModal: PropTypes.func,
        hideModal: PropTypes.func
    };

    static contextType = RuntimeContext;


    renderForModal = () => (
        <div className={'my-collection-v3'}>
            <div className={'tab-container'} style={{ textAlign: 'start' }}>
                {this.render()}
            </div>
        </div>
    );

    _openPromptsModal = () => {
        const { showModal, hideModal, loggedInUserCompany, userCollection } = this.props;
        showDownloadButton = false;

        showModal({
            modalType: MODALS.PRINT_PREVIEW_PROMPTS_MODAL,
            modalProps: {
                onClose: () => {
                    showDownloadButton = true;
                    return hideModal;
                },
                renderContent: this.renderForModal,
                collectionName: userCollection.name,
                companyName: loggedInUserCompany || '',
                pathsLogoUrl: this.context?.pathsWeb?.PATHS_LOGO_URL_CLOUDINARY,
            }
        });
    };

    // eslint-disable-next-line consistent-return
    _trackPromptIndex = (showOption, managerOnly, promptCount) => {
        const { SHOWN_TO_ALL, SHOWN_TO_MANAGERS } = PROMPT_TYPES;

        if (!managerOnly && showOption === SHOWN_TO_ALL) {
            showGroupHeading = true;
            return ++promptCount.showAllCount;
        }
        if (managerOnly && showOption === SHOWN_TO_MANAGERS) {
            showManagerHeading = true;
            return ++promptCount.managerOnlyCount;
        }
    };

    _downloadResources = (uploadedPdfRefGuides) => {
        const { loggedInUserCompany, isVerbAdmin } = this.props;
        if (uploadedPdfRefGuides.length) {
            return uploadedPdfRefGuides.forEach((guide) =>
                getFileWithSignedUrl(this.context.pathsWeb, guide, false).then((returnedUrl) =>
                    window.open(returnedUrl)
                )
            );
        }

        return null;
    };

    _referenceGuides = (resources) => {
        const uploadedPdfRefGuides = [];
        (resources || []).forEach((item) => {
            if (item.url.split('.').includes('pdf') || item.url.split('.').includes('PDF')) {
                uploadedPdfRefGuides.push(item.url.split(' ').join('+'));
            }
        });

        return uploadedPdfRefGuides;
    };

    _renderPrompts = (map) => <div className={'asset-prompts'}>{map}</div>;

    _mapPrompts = (row = [], managerOnly) => {
        const { SHOWN_TO_ALL, SHOWN_TO_MANAGERS } = PROMPT_TYPES;
        const promptCount = { managerOnlyCount: 0, showAllCount: 0 };

        const prompts = row.map(
            ({ value, showOption }, index) =>
                ((!managerOnly && showOption === SHOWN_TO_ALL) ||
                    (managerOnly && showOption === SHOWN_TO_MANAGERS)) && (
                    <div className={'prompt'} key={index}>
                        <span className={'far fa-quote-left prompt-icon'}></span>
                        <span>{`Discussion Prompt ${this._trackPromptIndex(
                            showOption,
                            managerOnly,
                            promptCount
                        )}: ${value}`}</span>
                    </div>
                )
        );
        return { prompts, promptCount };
    };

    // order assets as they appear for user
    _orderLearningAssets = (learningAssetsById = {}, collectionsAssets = []) =>
        collectionsAssets.reduce((accum, asset) => {
            accum.push(learningAssetsById[asset.learningAssetId ?? asset._id]);
            return accum;
        }, []);

    _renderPromptSection = (learningAsset = {}, managerOnly) => {
        const imageProps = IMAGE_PROPS.collectionImageCloudinary;
        const { prompts = [], promptCount = 0 } = this._mapPrompts(learningAsset.prompts || [], managerOnly);
        const showPromptsTitle = // only show prompt title if there are prompts for this type
            !!(managerOnly && promptCount.managerOnlyCount) || !!(!managerOnly && promptCount.showAllCount);
        return learningAsset.prompts && learningAsset.prompts.length ? (
            <div key={learningAsset._id} className={'single-prompt-section'}>
                {showPromptsTitle && (
                    <div className={'prompt-title'}>
                        <Image
                            src={learningAsset.thumbnailImageUrl}
                            cloudinaryCrop={imageProps.cloudinaryCrop}
                            className={'img-circle'}
                            dimension={{ h: 30, w: 30 }}
                            alt={'trackThumbnail'}
                        />
                        <span className={'asset-name'}>{learningAsset.name}</span>
                    </div>
                )}
                {this._renderPrompts(prompts)}
            </div>
        ) : null;
    };

    render() {
        const { learningAssetsById = [], isTeamAdmin, isVerbAdmin, isAccountOwner, userCollection = {} } = this.props;
        const { content, thumbnailImageUrl } = userCollection;

        const isManager = isTeamAdmin || isVerbAdmin || isAccountOwner;
        const orderedLearningAssets = this._orderLearningAssets(learningAssetsById, content);
        const defaultPrompt = {
            ...DEFAULT_DISCUSSION_PROMPTS,
            thumbnailImageUrl
        };
        orderedLearningAssets.unshift(defaultPrompt);
        return (
            <div className={'container my-collection-track-discussion-tab'}>
                {isManager && (
                    <Fragment>
                        <div>
                            <div className={'col-12 pdf-button-group'}>
                                {showDownloadButton && (
                                    <span className={'pdf-download-button'}>
                                        <VerbButton
                                            onClick={this._openPromptsModal}
                                            buttonText={'DOWNLOAD PROMPTS'}
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                                        />
                                    </span>
                                )}
                            </div>
                            {showManagerHeading && (
                                <VerbHeading
                                    hNumber={5}
                                    messageId={'Manager Discussion Prompts'}
                                    defaultMessage={'Manager Discussion Prompts'}
                                    className={`${
                                        showDownloadButton ? 'col-sm-8 col-6' : 'col-sm-12 col-12'
                                    } discussion-prompt-heading`}
                                />
                            )}
                        </div>
                        <div className={'discussion-prompts'}>
                            {orderedLearningAssets.map((asset) => this._renderPromptSection(asset, true))}
                        </div>
                    </Fragment>
                )}
                {!isManager && showDownloadButton && (
                    <>
                        <div className={'pdf-button-group'}>
                            <div className={'pdf-download-button single-prompt-button'}>
                                <VerbButton
                                    onClick={this._openPromptsModal}
                                    buttonText={'DOWNLOAD PROMPTS'}
                                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                                />
                            </div>
                        </div>
                    </>
                )}
                <div style={{ marginTop: 40 }}>
                    {showGroupHeading && (
                        <VerbHeading
                            hNumber={5}
                            messageId={'Group Discussion Prompts'}
                            defaultMessage={'Group Discussion Prompts'}
                            className={`${
                                !isManager && showDownloadButton
                                    ? 'col-sm-8 col-6'
                                    : 'col-sm-12 col-12 group-discussion-no-download-button'
                            } discussion-prompt-heading`}
                        />
                    )}
                    <div className={'discussion-prompts'}>
                        {orderedLearningAssets.map((asset) => this._renderPromptSection(asset, false))}
                    </div>
                </div>
            </div>
        );
    }
}
